import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use( Vuetify );

export default new Vuetify( {
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary: '#001e61',
                secondary: '#ff671d',
                accent: '#e64b38',
                error: '#b71c1c',
            },
        },
    },
} );
